import { UrlMatchResult, UrlSegment } from '@angular/router';

export function resultsMatcher(url: UrlSegment[]): UrlMatchResult {
  const regex: RegExp = /^(hotels|hoteles|hoteis)\/(results|resultados|destinos)\//;
  const match = regex.test(url.join('/'));
  return match ? { consumed: url, posParams: { query: url[url.length - 1] } } : null;
}
